/**
 * @generated SignedSource<<e415793e9faa41e7df0639aad959767f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type useNovaAvailableAgentsQuery$variables = {};
export type useNovaAvailableAgentsQuery$data = {
  readonly viewer: {
    readonly novaAgentsForInvocation: ReadonlyArray<{
      readonly agentId: string;
      readonly title: string;
      readonly description: string | null;
      readonly category: string;
      readonly isDefault: boolean;
    }>;
  } | null;
};
export type useNovaAvailableAgentsQuery = {
  variables: useNovaAvailableAgentsQuery$variables;
  response: useNovaAvailableAgentsQuery$data;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "NovaAgentInvocationSummary",
  "kind": "LinkedField",
  "name": "novaAgentsForInvocation",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "agentId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "category",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDefault",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "useNovaAvailableAgentsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "useNovaAvailableAgentsQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          (v0/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3ae2f396ee0f3cf7e481a611693dc6b9",
    "id": null,
    "metadata": {},
    "name": "useNovaAvailableAgentsQuery",
    "operationKind": "query",
    "text": "query useNovaAvailableAgentsQuery {\n  viewer {\n    novaAgentsForInvocation {\n      agentId\n      title\n      description\n      category\n      isDefault\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "1121bc9a5d4a1f2cfa93fcf580f96f59";

export default node;
